import React, { useEffect, useState } from 'react';
import MissionIntroVideoScreen from './MissionIntroVideoScreen';
import PictureQuizGreetingScreen from './PictureQuizGreetingScreen';
import PictureQuizRunner from './PictureQuizRunner';

export function resolvePictureQuizIntroUrl(spot, sharedIntroVideoUrl = null) {
  if (!spot || spot.mission_type !== 'picture_quiz') return null;
  const urls = [sharedIntroVideoUrl, spot.mission_video_url, spot.intro_video_url];
  const url = urls.find((candidate) => typeof candidate === 'string' && candidate.trim());
  return url ? url.trim() : null;
}

export function resolvePictureQuizGreetingUrl(config, sharedOxConfig = null) {
  // OX 공용 인사 영상에는 OX 문구와 O/X 표식이 영상 자체에 포함되어 있다.
  // 그림 퀴즈에서는 전용 URL만 사용하고, 없으면 전용 정적 인사 화면을 쓴다.
  const url = config?.greeting_video_url;
  void sharedOxConfig;
  return typeof url === 'string' && url.trim() ? url.trim() : null;
}

export default function PictureQuizMissionFlow({
  spot, config, sharedIntroVideoUrl, sharedVerdictConfig, spotName, memberNickname,
  onComplete, onCancel, onVideoAbort,
}) {
  const introVideoUrl = resolvePictureQuizIntroUrl(spot, sharedIntroVideoUrl);
  const greetingVideoUrl = resolvePictureQuizGreetingUrl(config, sharedVerdictConfig);
  const initialPhase = () => (introVideoUrl ? 'intro' : 'greeting');
  const [phase, setPhase] = useState(initialPhase);

  useEffect(() => setPhase(initialPhase()), [spot?.id, introVideoUrl, greetingVideoUrl]);

  if (phase === 'intro') {
    return (
      <MissionIntroVideoScreen
        ariaLabel="그림 퀴즈 시작 영상"
        logLabel="그림 퀴즈 인트로 영상"
        videoUrl={introVideoUrl}
        onFinished={() => setPhase('greeting')}
        onAbort={onVideoAbort}
      />
    );
  }

  if (phase === 'greeting') {
    return (
      <PictureQuizGreetingScreen
        videoUrl={greetingVideoUrl}
        memberNickname={memberNickname}
        onFinished={() => setPhase('quiz')}
        onAbort={onVideoAbort}
      />
    );
  }

  return (
    <PictureQuizRunner
      config={config}
      sharedVerdictConfig={sharedVerdictConfig}
      spotName={spotName}
      onComplete={onComplete}
      onCancel={onCancel}
      onVideoAbort={onVideoAbort}
    />
  );
}
